import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string; // <- opcional y estrictamente tipado
}

export default function Card({
  children,
  className = "",
}: CardProps): React.ReactElement {
  return <div className={`card ${className}`}>{children}</div>;
}
